<ng-container *ngIf="isMobile$ | async; else isNotMobile">
  <div class="termsAndCondition">
    <p class="circleDisclaimer">
      {{ tacLabels[flowType]?.mobilePara1?.stringOne }}
      <a
        href="#"
        (click)="openDialog(tacLabels?.disclaimerLinks?.circleTerms)"
        >{{ tacLabels?.disclaimerLabels.usdcUserAgreement }}</a
      >{{ beginsWithComma(tacLabels[flowType]?.mobilePara1?.stringTwo)
      }}{{ tacLabels[flowType]?.mobilePara1?.stringTwo }}
      <a
        href="#"
        (click)="openDialog(tacLabels?.disclaimerLinks?.circleAccpPolicy)"
        >{{ tacLabels?.disclaimerLabels.applicableUsePolicy }}</a
      >
      {{ tacLabels?.and }}
      <a
        href="#"
        (click)="openDialog(tacLabels?.disclaimerLinks?.circlePolicy)"
        >{{ tacLabels?.disclaimerLabels.privacyPolicy }}</a
      >{{ beginsWithPeriod(tacLabels[flowType]?.mobilePara1.stringThree)
      }}{{ tacLabels[flowType]?.mobilePara1.stringThree }}
    </p>
    <p class="mgDisclaimer">
      <span>{{ tacLabels[flowType]?.mgDisclaimerPara2 }}</span>
    </p>
    <p class="agreement">
      {{ tacLabels?.mgAgreementPara3.mobile.stringOne }}
      <a href="#" (click)="openDialog(tacLabels?.disclaimerLinks?.mgTandC)">{{
        tacLabels?.disclaimerLabels.termsAndConditionsLabel
      }}</a
      >{{ beginsWithPeriod(tacLabels?.mgAgreementPara3.mobile.stringTwo)
      }}{{ tacLabels?.mgAgreementPara3.mobile.stringTwo
      }}{{ checkFrenchArticle(tacLabels?.mgAgreementPara3.mobile.stringTwo) }}
      <a href="#" (click)="openDialog(tacLabels?.disclaimerLinks?.mgPrivacy)">{{
        tacLabels?.disclaimerLabels.privacyNotice
      }}</a
      >{{ beginsWithPeriod(tacLabels?.mgAgreementPara3.mobile.stringThree)
      }}{{ tacLabels?.mgAgreementPara3.mobile.stringThree }}
    </p>
  </div>
</ng-container>
<ng-template #isNotMobile>
  <div class="termsAndCondition">
    <p
      class="mg-step-disclaimer mat-caption"
      class="circleDisclaimer"
      [innerHTML]="tacLabels[flowType]?.webPara1"
    ></p>
    <p
      class="mg-step-disclaimer mat-caption"
      class="mgDisclaimer"
      [innerHTML]="tacLabels[flowType]?.mgDisclaimerPara2"
    ></p>
    <p
      class="mg-step-disclaimer mat-caption"
      class="agreement"
      [innerHTML]="agreement"
    ></p>
  </div>
</ng-template>
